@if (!showSpinner) {
  <div class="pin-page" [ngClass]="{ fh: hasPassCode }">
    <div class="content" [ngClass]="{ width_50p: hasPassCode }">
      <div class="form">
        <img class="logo appear_anim_1" src="../../assets/logo-v2.svg" alt="" />
        @if (!hasPassCode) {
          <img
            class="pic appear_anim_1"
            src="../../assets/pin-set.svg"
            alt=""
          />
        }
        <div class="appear_anim_2">
          @if (hasPassCode) {
            <div class="celo-text-32">Welcome back!</div>
          }
          @if (hasPassCode) {
            <div class="celo-text-14 celo-grey">
              @if (expired === "true") {
                <span>
                  @if (lockoutPeriodMinutes$ | async; as lockoutPeriodMinutes) {
                    You were inactive for
                    {{ lockoutPeriodMinutes | number: "1.0-0" }} minutes.
                  } @else {
                    You were inactive for too long.
                  }
                </span>
              }
              Please enter your PIN to continue.
            </div>
          }
          @if (!hasPassCode) {
            <div>
              <div class="celo-bold celo-text-18">Set up your PIN number</div>
              <div class="celo-grey celo-text-14">
                Enter a 4 digit PIN. You will use this to easily access the Celo
                app on this device.
              </div>
            </div>
          }
        </div>
        <div class="celo-input-outline-standard-height fields appear_anim_3">
          @if (!hasPassCode) {
            <mat-form-field appearance="outline" class="fw">
              <input
                matInput
                id="pin_code"
                class="fw pin"
                type="text"
                inputmode="numeric"
                placeholder="Pin number"
                required
                minlength="4"
                autocomplete="off"
                maxlength="4"
                autocomplete="off"
                autofocus
                [(ngModel)]="passcode0"
                name="passcode"
                #passcode="ngModel"
                #setPasscode
                appNumericPassword
              />
            </mat-form-field>
          }
          <mat-form-field appearance="outline" class="fw">
            <input
              matInput
              id="pin_code_confirm"
              class="fw pin"
              type="text"
              inputmode="numeric"
              [placeholder]="hasPassCode ? 'Enter Pin' : 'Re-enter your pin'"
              autocomplete="off"
              required
              minlength="4"
              maxlength="4"
              autocomplete="off"
              [(ngModel)]="passcode"
              (keyup.enter)="
                (hasPassCode || passcode0 === passcode) && submit()
              "
              (ngModelChange)="
                hasPassCode && passcode.length === 4 ? onSubmit() : ''
              "
              name="passcodeConfirm"
              #passcodeConfirm="ngModel"
              #myPasscode
              appNumericPassword
            />
          </mat-form-field>
          @if (
            !hasPassCode &&
            passcode0 !== passcode &&
            passcode &&
            passcode.length === 4
          ) {
            <div class="celo-grey celo-text-14 appear_2 error-text">
              PINs do not match. Please re-enter.
            </div>
          }
        </div>
        @if (!hasPassCode) {
          <div class="buttons appear_anim_4">
            <button
              [disabled]="
                !passcode0 ||
                !passcode ||
                passcode0 !== passcode ||
                passcode0?.length !== 4 ||
                passcode?.length !== 4
              "
              class="celo-primary-button fw"
              mat-button
              [color]="'primary'"
              (click)="submit()"
            >
              NEXT
            </button>
          </div>
        }
        <div class="appear_anim_4 logout">
          @if (!hasPassCode) {
            <div class="appear_anim_3 celo-link">
              <a (click)="logout('Pin screen')">Logout</a>
            </div>
          }
          @if (hasPassCode) {
            <div class="appear_anim_3 celo-link">
              <a (click)="forgotPin()">Forgot PIN</a>
            </div>
          }
          @if (hasPassCode) {
            <div class="appear_anim_4 celo-link">
              <a (click)="forgotPin()">Sign in with a different account</a>
            </div>
          }
        </div>
      </div>
    </div>
    @if (hasPassCode) {
      <div class="cover">
        <img class="set-pin-pic" src="../../assets/splash-screen.png" alt="" />
      </div>
    }
  </div>
}
@if (showSpinner) {
  <div class="loading-screen">
    <app-empty-state
      [no_message]="true"
      [isLoading]="true"
      [spinner]="false"
      [animation]="true"
      [diameter]="70"
    ></app-empty-state>
  </div>
}
@if (!production) {
  <div class="version">{{ version }}</div>
}
